"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasContent = hasContent;
exports.valid = valid;
exports.empty = empty;
exports.isDeliverableToEmailAddress = isDeliverableToEmailAddress;
exports.isDeliverableToRecipient = isDeliverableToRecipient;
exports.isVerifiedSender = isVerifiedSender;
exports.okToDeliver = okToDeliver;
exports.okToEdit = okToEdit;
exports.okToSend = okToSend;
exports.performIntegrationCheck = performIntegrationCheck;
exports.performInboxIntegrationCheck = performInboxIntegrationCheck;
exports.isValidEmail = isValidEmail;
exports.isEmailInNeverLogList = void 0;

var _IntegrationStatusAlerts = require("customer-data-email/schema/email/IntegrationStatusAlerts");

var _EmailAddress = _interopRequireDefault(require("PatternValidationJS/patterns/EmailAddress"));

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var nonWhitespaceRegExp = /[^\s]/;

var isMatch = function isMatch(s, regExp) {
  return !!s && regExp.test(s);
};

function hasContent(field) {
  return isMatch(field, nonWhitespaceRegExp);
}

function valid(subject, bodyRteResults) {
  return hasContent(subject) && bodyRteResults.hasContent();
}

function empty(subject, bodyRteResults) {
  return !hasContent(subject) && !bodyRteResults.hasContent();
}

function isDeliverableToEmailAddress(emailAddress, deliverability) {
  var recipientDeliverability = deliverability.get(emailAddress);

  if (!recipientDeliverability) {
    return true;
  }

  if (recipientDeliverability.hasStatus()) {
    return recipientDeliverability.deliverable();
  }

  return true;
}

function isDeliverableToRecipient(sender, recipient, deliverability) {
  if (recipient.to.exists() && !recipient.to.hasAddress()) {
    return false;
  }

  if (sender.hasIntegration()) {
    return true;
  }

  return isDeliverableToEmailAddress(recipient.to.address, deliverability);
}

function isVerifiedSender(hasScope) {
  return hasScope('verified-email');
}

function okToDeliver(sender, recipient, deliverability) {
  return isDeliverableToRecipient(sender, recipient, deliverability);
}

function okToEdit(sender, recipient, deliverability, hasScope) {
  return isVerifiedSender(hasScope) && isDeliverableToRecipient(sender, recipient, deliverability);
}

function okToSend(sender, recipient, deliverability, bodyRteResults, subject, hasScope) {
  return recipient.to.hasAddress() && valid(subject, bodyRteResults) && okToEdit(sender, recipient, deliverability, hasScope);
}

function performIntegrationCheck(connectedAccounts, senderEmailAddressId) {
  if (!connectedAccounts.isIntegrated(senderEmailAddressId)) {
    return _IntegrationStatusAlerts.connectAccountInbox;
  }

  if (connectedAccounts.isDisabled(senderEmailAddressId)) {
    return _IntegrationStatusAlerts.enable;
  }

  if (connectedAccounts.isDisconnected(senderEmailAddressId)) {
    return _IntegrationStatusAlerts.reconnect;
  }

  return false;
}

function performInboxIntegrationCheck(senderRecord) {
  if (senderRecord.hasEnabledAccounts) {
    return false;
  }

  return _IntegrationStatusAlerts.connectInbox;
}

function isValidEmail(emailAddress) {
  return _EmailAddress.default.test(emailAddress);
}

var isEmailInNeverLogList = (0, _memoize.default)(function (neverLogList, email) {
  return neverLogList && neverLogList.find(function (emailObject) {
    if (emailObject.get('type') === 'DOMAIN') {
      var domainStartIndex = email.indexOf('@');
      var domain = email.slice(domainStartIndex + 1);
      return emailObject.get('value') === domain;
    }

    return emailObject.get('value') === email;
  });
});
exports.isEmailInNeverLogList = isEmailInNeverLogList;